'use client'
import { getCore, createApiClient } from '@dynamic-labs-sdk/client/core';
import { MFADeviceType } from '@dynamic-labs/sdk-api-core';

const verifyTotpMfaDevice = (client, { code }) => {
    const core = getCore(client);
    const apiClient = createApiClient(client);
    return apiClient.registerTotpMfaDeviceVerify({
        environmentId: core.environmentId,
        mFARegisterTotpDevicePostRequest: {
            code,
            type: MFADeviceType.Totp,
        },
    });
};

export { verifyTotpMfaDevice };
